import React from "react";

const Lightning = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="73"
    height="72"
    viewBox="0 0 73 72"
    fill="none"
    {...props}
  >
    <path
      d="M39.5 6L9.5 42H36.5L33.5 66L63.5 30H36.5L39.5 6Z"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Lightning;
